import { render } from "./NoDataComponent.vue?vue&type=template&id=310bb1b8&scoped=true"
import script from "./NoDataComponent.vue?vue&type=script&lang=js"
export * from "./NoDataComponent.vue?vue&type=script&lang=js"

import "./NoDataComponent.vue?vue&type=style&index=0&id=310bb1b8&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310bb1b8"]])

export default __exports__